import { Link, useNavigate,useParams } from "react-router-dom";
import React, { useState, useEffect } from "react"
import axios from "axios";
import { linksurl } from '../../../apis/urls'
import { decode } from "html-entities";


const ViewLink = () => {

    useEffect(() => {
        LinkListing();
    },[]
    );

    let navigate = useNavigate();
    let urole = localStorage.getItem('userrole');

    let token = "Bearer "+localStorage.getItem('token');
    // console.log(token)

    const instance = axios.create({
        baseURL: linksurl,
        timeout: 1000000,
        headers: {'authorization': token}
      });


    const { id } = useParams();
    const[ result,setResult ] = useState('');

    const LinkListing = ()=>{
        let token = "Bearer "+localStorage.getItem('token');
        console.log(token)

        const instance = axios.create({
            baseURL: linksurl+'/'+id,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {
            //console.log(res.data.data)
            setResult(res.data.data);
          });
    }

    const URI = linksurl
    const removeAccreditations = (id) => {
        let r = window.confirm("Are you sure you want to delete this Link?");
        if(r == true){
        try {

            instance.delete(`${URI}/${id}`).then((response) =>{
                navigate("/links")
            })
            console.log('Item successfully deleted.')
        } catch (error) {
          alert(error)
          console.log(error)
        }
      }
    }

    return(
        <div>
            <aside class="right-side areas">    
                <div class="content-area dash-contentss">
                   
                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <i class="icon-library1"></i>
                            <h2 class="page-title">{decode(result.link_text)}</h2>
                        </div>

                        <div class="page-rightside-action-column"></div>
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/links">Link</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Link View({decode(result.link_text)})</li>
                        </ol>
                    </nav>

                    <div className="tab-content">

                        <div id="generalinfo" class="container tab-pane active"><br/>
                            <div class="row tab-section">
                                <div class="col-md-6">
                                    <label>Link Title</label>
                                    <div>{decode(result.link_text)}</div>
                                </div>
                                <div class="col-md-6">
                                    <label>Url</label>
                                    <div>
                                    <a href={decode(result.link_url)} target={result.link_target}>{decode(result.link_text)}</a><br/>
                                    </div>
                                </div>
                            
                                
                            </div>

                            <div class="row tab-section">
                                <div class="col-md-6">
                                    <label>Link Target</label>
                                    <div>{result.link_target}</div>
                                </div>
                                <div class="col-md-6">
                                    <label>Stattus</label>
                                    <div>{result.status}</div>
                                </div>
                            </div>
                            {urole === "SUPERADMIN"?
                            <div className="list-action-wrpr showicons roundicons-text">
									<div className="list-action-wrpr">
										<Link   to={"/edit_links/"+id}  data-toggle="tooltip" title="Edit">
											<i class="edit icon-pencil3"></i><span>Update</span>
										</Link>
                                        <button data-toggle="tooltip" 
                                        style={{backgroundColor: '#fff'}} onClick={ ()=> { removeAccreditations(id) } }  title="Delete"  ><a><i  class="delete icon-close1"
                                        ></i><span>Delete</span></a></button>

									</div>
								</div>:null}


                        </div>

                    </div>
                    


                </div>
            </aside>

        </div>
    )
}

export default ViewLink;